import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ChatService } from '../../services/chat.service';
import { EventResponse, CompanyResponse } from '../../models/response.module';
import { ToastService } from '../../../@core/services/toast.service';

@Component({
  selector: 'app-send-message-modal',
  standalone: false,
  templateUrl: './send-message-modal.component.html',
  styleUrl: './send-message-modal.component.css'
})
export class SendMessageModalComponent implements OnInit {
  @Input() event: EventResponse | null = null;
  @Input() company: CompanyResponse | null = null;

  messageText: string = '';
  subject: string = '';
  isSending: boolean = false;
  errorMessage: string = '';
  submitted: boolean = false;

  // Validation helpers
  get isMessageInvalid(): boolean {
    return this.submitted && !this.messageText.trim();
  }

  get isFormValid(): boolean {
    return !!this.messageText.trim();
  }

  constructor(
    public activeModal: NgbActiveModal,
    private chatService: ChatService,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    if (this.event) {
      this.subject = `Question about ${this.event.event_name}`;
    } else if (this.company) {
      this.subject = `Question for ${this.company.company_name}`;
    }
  }

  sendMessage() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error('Please enter a message');
      return;
    }

    this.isSending = true;
    this.errorMessage = '';

    // Determine company_id: use direct company input, or fall back to event's company
    const companyId = this.company?.company_id || this.event?.company_id || undefined;

    this.chatService.startConversation({
      event_id: this.event?.event_id,
      company_id: companyId,
      subject: this.subject || undefined,
      initial_message: this.messageText.trim()
    }).subscribe({
      next: (response) => {
        this.isSending = false;
        if (response.data) {
          this.toastService.success('Message sent successfully');
          this.activeModal.close(response.data);
          // Navigate to the chat page with the new conversation
          this.router.navigate(['/chat'], {
            queryParams: { conversation: response.data.conversation_id }
          });
        }
      },
      error: (err) => {
        this.isSending = false;
        this.errorMessage = err.error?.reason || 'Failed to send message. Please try again.';
        this.toastService.error(this.errorMessage);
      }
    });
  }

  close() {
    this.activeModal.dismiss();
  }
}
